import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  fetchProductBySlug,
} from "./../../redux/actions/productActions";
import { Select, Tooltip, notification, Skeleton } from "antd";
import "./style.css";
import { getProductCartQuantity } from "../../helpers/product";
import { defaultLogo, saleBadgeFour, UNIT } from "../../pages/constant/Constants";
import { useToasts } from "react-toast-notifications";
import { DropdownInput } from "../../components/product/DropdownInput";
import { defaultImageUrl } from "../../pages/constant/Constants";
import { Row } from "antd";
import Upcoming from "./../../assets/images/Upcoming.png";
import NewFeaturedSkelton from "./NewFeaturedProductSkelton";
import { trimStringAndAddEllipsis } from "../../components/utils/utils";
import { formatCurrency, isProductTobaccoEligible, refModal } from "../../pages/constant/utils";
import Promotions from "../../components/common/Promotions";
import PromotionsPrice from "../../components/common/PromotionPrice";
import PromotionsQTY from "../../components/common/PromotionQTY";

const NewFeaturedProduct = ({
  product,
  currency,
  addToCart,
  spaceBottomClass,
  settingData,
  themeSettingData,
  cartItems,
  userDetail,
  spaceTopClass,
  bgShape,
  userData,
  sliderClassName,
}) => {
  const [quantityCount, setQuantityCount] = useState("00");
  const history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  let modalRef = useRef(null);
  const minBackOrderQty = 5
  const productsUnit = themeSettingData?.show_unit_products 
  const licensePath = () => history.push('/profile/my-account')
  const [selectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );
  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize
  );


  const isWishedList = (product, wishlistItems) => { };

  const handleWishlist = () => { };

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  const handleProductClick = () => {
    dispatch(
      fetchProductBySlug(
        product,
        () => history.push(`/product/${product.slug}`),
        () => history.push('/shop')
      )
    );
  };
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (
      !product.back_order_ecom &&
      (["", 0, null].includes(quantityCount) ||
        productCartQty + Number(quantityCount) > product.saleable_qty)
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [quantityCount, productCartQty, product]);
  return (
    <>
      {isLoading && <NewFeaturedSkelton />}
      {!isLoading && (
        <div
          className={`product-area product-area--style2 ${spaceTopClass ? spaceTopClass : ""
            }`}

        >
          <div className="product-tab-slider-wrapper position-relative">
            <div className="space-evenly">
              <div className={`card`}>
                <div>
                  <div className={`rectangle ${product.images[0] === defaultImageUrl ? "default-logo-feature" : ""}`}>
                    <Link
                      to={`/product/${product.slug}`}
                      onClick={handleProductClick}
                      className="rectangle"
                      style={{ cursor: "pointer" }}
                    >
                      
                      <img
                        className={`card-image ${product.images[0] || product?.images_seo[0] || product?.default_image === defaultImageUrl ? "" : ""}`}
                        // className={product.images[0] !== defaultImageUrl ? "card-image" : ""}
                        src={
                          product?.default_image === defaultImageUrl
                            ? (themeSettingData.logo === defaultLogo ? Upcoming : themeSettingData.logo)
                            : process.env.PUBLIC_URL + (product?.default_image || product?.images[0]) 
                        }
                        alt=""
                        style={
                          product?.default_image == defaultImageUrl
                            ? { backgroundColor: "#f7f7f7" }
                            : {}
                        }
                      />
                      <Promotions product={product} classMain={"promotion-home"} classText={product?.selected_unit_price?.promotion?.sale_badge_template === saleBadgeFour ? "promotion-text-home-four" : "promotion-text-home"}/>
                    </Link>
                  </div>
                  {/* {product.images.length > 1 && (
                  <div
                    // onClick={() => {
                    //   dispatch(
                    //     fetchProductBySlug(
                    //       product,
                    //       () => {
                    //         history.push(`/product/${product.slug}`);
                    //       },
                    //       () => {
                    //         history.push(`/shop`);
                    //       }
                    //     )
                    //   );
                    // }}
                    className="rectangle"
                  >
                    <Link
                      onClick={() => {
                        dispatch(
                          fetchProductBySlug(
                            product,
                            () => {
                              history.push(`/product/${product.slug}`);
                            },
                            () => {
                              history.push(`/shop`);
                            }
                          )
                        );
                      }}
                    >
                      <img
                        className="card-image"
                        src={process.env.PUBLIC_URL + product.images[1]}
                        alt=""
                      />
                    </Link>
                  </div>
                )}
                {/* <Component className="component-24" divClassName="component-instance" property1="frame-1686556945" /> */}
                  <div className="frame-2">
                    <div className="frame-3">
                      <div style={{ display: "flex", gap: "8px" }}>

                        <div className="frame-4">
                          <div className="text-wrapper-3">
                            {/* {} */}
                            {trimStringAndAddEllipsis(product?.category_name, 12)}
                          </div>
                        </div>
                        {(product?.product_variant_attribute.length == 0) && ((!userDetail?.user && themeSettingData.stock_display_for_unsecure_user) ||
                          (userDetail?.user && themeSettingData.stock_display_for_secure_user)) && (
                            <div
                              className="frame-5"
                              style={{
                                background: product?.back_order_ecom && product?.saleable_qty <= minBackOrderQty ? "#FFEAB9" : product.saleable_qty <= 0 ? "transparent" : "#EFEDF8",

                              }}
                            >
                              <div
                                className="text-wrapper-4"
                                style={{
                                  color: product?.back_order_ecom && product?.saleable_qty <= minBackOrderQty ? "#1D1600" : product?.saleable_qty <= 0 ? "" : "#5F4BB6",

                                }}
                              >
                                {
                                  trimStringAndAddEllipsis(product?.back_order_ecom && product?.saleable_qty <= minBackOrderQty
                                    ? "Low Stock"
                                    : product?.saleable_qty <= 0
                                      ? ""
                                      : `Qty: ${product.saleable_qty || 0}`, 12)
                                }
                              </div>
                            </div>
                          )}
                      </div>

                    </div>
                    <h3 className="product-name" onClick={handleProductClick}>{product?.group_name || product?.ecom_name || product?.name}</h3>
                    {((!userDetail?.user && themeSettingData.price_display_for_unsecure_user) ||
                      (userDetail?.user && themeSettingData.price_display_for_secure_user)) && (
                        <div style={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                        <div className="frame-6">
                          <div className="text-wrapper-5">
                            <PromotionsPrice product={product} regularprice={true} currency={currency.currency_symbol}/>
                          </div>
                        </div>
                        <div>
                          {product?.is_tax_inclusive && 
                            <p className="tax-inclusive">Tax Inclusive</p>
                            }
                        </div>
                        </div>
                      )}

                  </div>

                  {!product?.vg_id && (
                    <div className="frame-7">
                      <div className="frame-8" style={{justifyContent: productsUnit ? "space-between" :"end"}}>
                      {productsUnit &&
                        <div
                          className="shop-page-unit"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "4px",
                            border:"1px solid #e6e6e6",
                            borderRadius:"32px"
                          }}
                        >
                          <Select
                            disabled
                            value={product.selected_unit_price.unit}
                            className="unit-select"
                          >
                            {Object.keys(UNIT).map((unit) => (
                              <Select.Option value={UNIT[unit].value}>
                                {UNIT[unit].name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        }
                        {/* <div className="text-wrapper-3-sku">
                        {product?.sku} / {product?.upc}
                      </div> */}
                        <div className="text-wrapper-3-sku">
                          <Tooltip title={
                            themeSettingData.sku_display_on_product_card && product?.sku && themeSettingData.upc_display_on_product_card && product?.upc
                              ? `${product.sku} / ${product.upc}`
                              : themeSettingData.sku_display_on_product_card && product?.sku
                                ? product.sku
                                : themeSettingData.upc_display_on_product_card && product?.upc
                                  ? product.upc
                                  : ''
                          }>
                            <span>
                              {themeSettingData.sku_display_on_product_card && product?.sku && themeSettingData.upc_display_on_product_card && product?.upc
                                ? `${product.sku}/${product.upc}`.length > 9
                                  ? `${product.sku}/${product.upc}`.substring(0, 9) + '...'
                                  : `${product.sku} / ${product.upc}`
                                : themeSettingData.sku_display_on_product_card && product?.sku
                                  ? product.sku
                                  : themeSettingData.upc_display_on_product_card && product?.upc
                                    ? product.upc
                                    : ''
                              }
                            </span>
                          </Tooltip>
                        </div>

                      </div>
                      <div className="frame-9" style={{ justifyContent: !product?.back_order_ecom && product?.saleable_qty <= 0 ? "end" : "space-between" }}>
                      {product?.back_order_ecom ||!product?.saleable_qty <= 0 ? (
                        <div className="frame-10">
                          <div className="text-wrapper-7">
                            <DropdownInput
                            incrementMainclass={"increment-home-page"}
                            incrementSubClass={"increment-class"}
                            inputCardClass={"new-input-card"}
                              decrement={() =>
                                setQuantityCount(
                                  Number(quantityCount) > 1
                                  ? Number(quantityCount) - 1
                                  : 0
                                )
                              }
                              increment={() => {
                                if (
                                  isProductTobaccoEligible(product, userData, settingData)
                                ) {
                                  setQuantityCount(
                                    !product.back_order_ecom
                                    ? Number(quantityCount) < product.saleable_qty
                                    ? Number(quantityCount) + 1
                                    : Number(quantityCount)
                                    : Number(quantityCount) + 1
                                  );
                                } else {
                                  refModal(modalRef,licensePath)
                                }
                              }}
                              value={quantityCount || "00"}
                              handleChange={({ target: { value } }) => {
                                const formattedValue = value.replace(/\D/g, "");
                                if (
                                  !product.back_order_ecom &&
                                  Number(formattedValue) > product.saleable_qty
                                ) {
                                  notification.error({
                                    message:
                                    "You can not add more than in stock quantity",
                                  });
                                  return;
                                }
                                setQuantityCount(formattedValue);
                              }}
                              style={{
                                marginLeft: "9px",
                                background: "#80808000",
                                border: "none",
                              }}
                            />
                          <label className="quantity"><PromotionsQTY selectedVariant={product}/></label>
                          </div>
                        </div>
                        ) : null}
                        <button
                          type="button"
                          className={!product?.back_order_ecom && product?.saleable_qty <= 0 ? "out-of-stock-home" : "add-to-cart"}
                          disabled={
                            !product?.back_order_ecom && product?.saleable_qty <= 0
                          }
                        
                          onClick={() => {
                            if (!userDetail?.user) {
                              addToast("Please login first to add in the cart", {
                                appearance: "info",
                                autoDismissTimeout: 1000,
                                autoDismiss: true,
                              });
                            }else if(product?.eligibility_check && !product?.eligibility_check?.is_eligible){
                              notification.error({message:`Sale of this ${product?.name} is not allowed due to ${product?.eligibility_check?.reasons}. Please upload the license in the 'Profile' section to make a purchase.`})
                             } else {
                              if (isDisabled) {
                                notification.error({
                                  message: "You can not add more than in stock quantity",
                                });
                                return;
                              }
                              if (
                                isProductTobaccoEligible(product, userData, settingData)
                              ) {
                                
                                addToCart(
                                  product,
                                  addToast,
                                  cartItems,
                                  Number(quantityCount),
                                  settingData.channel_id,
                                );
                                
                              } else {
                                refModal(modalRef,licensePath)

                              }
                            }
                          }}
                        >
                          {!product?.back_order_ecom && product?.saleable_qty <= 0
                      ? "Out of Stock" : "Add to Cart"}
                        </button>
                      </div>
                    </div>
                    
                  )}

{product?.variant_product_images?.length>0 && product?.variant_product_images[0].id!==null && <div
                      className="varient-images-wraper"
                    >
                      <Row className="varient-images-row ">
                        {product?.variant_product_images[1] && product?.variant_product_images?.filter((image) => image.images[0] != defaultImageUrl)?.slice(0, 5)?.map((image) => (
                           <>
                          {image?.images[0] != defaultImageUrl && (
                            <div
                              className="thumbnail-2"
                              style={{
                                margin: "5px",
                                // height: "45px",
                                display: `${!image?.images[0] ? "none" : ""}`,
                              }}
                              onClick={handleProductClick}
                            >
                              <img src={image?.images[0]} alt="Image" />
                            </div>
                          )}
                        </>
                      ))}
                    </Row>
                  </div>}

                  {product?.vg_id ? (
                    <div className="variant-button-on-vertical-card">
                      <button
                        className="add-to-cart"
                        onClick={() => {
                          history.push(`/product/${product.slug}`);
                          // dispatch(
                          //   fetchProductBySlug(
                          //     product,
                          //     () => {
                          //       history.push(`/product/${product.slug}`);
                          //     },
                          //     () => {
                          //       history.push(`/shop`);
                          //     }
                          //   )
                          // );
                        }}
                      >
                        View Variants
                      </button>
                    </div>
                  ) : null}

                </div>
              </div>
            </div>
          </div>

          {bgShape ? (
            <div className="bg-png-1">
              <img
                src={process.env.PUBLIC_URL + "/assets/img/bg/shape-2.png"}
                alt=""
              />
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

NewFeaturedProduct.propTypes = {
  bgColorClass: PropTypes.string,
  product: PropTypes.object,
  colorClass: PropTypes.string,
  bgShape: PropTypes.bool,
  category: PropTypes.string,
  currency: PropTypes.object,
  userData: PropTypes.object,
  sectionTitle: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  settingData: PropTypes.object,
  themeSettingData: PropTypes.object,
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  cartItems: PropTypes.array,
  compareItem: PropTypes.object,
  sliderClassName: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItem: PropTypes.object,
  settings: PropTypes.object,
  userDetail: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    settingData: state.settingData.ecom.basic,
    themeSettingData: state.settingData.ecom.theme,
    currency:state.settingData?.["admin-panel"]?.basic||{},
    userData: state.userData.user,
    settings: state.settingData.ecom.basic,
    cartItems: state.cartData,
    userDetail: state.userData,
  };
};
export default connect(mapStateToProps)(NewFeaturedProduct);